import { render } from "./addr.vue?vue&type=template&id=a276532c&scoped=true"
import script from "./addr.vue?vue&type=script&lang=js"
export * from "./addr.vue?vue&type=script&lang=js"

import "./addr.vue?vue&type=style&index=0&id=a276532c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a276532c"]])

export default __exports__